<p-table #dt [columns]="cols" [(value)]="dados" [rowHover]="true" [loading]="loading" [scrollable]="true"
  scrollHeight="50vh"
  styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
  sortMode="multiple" [globalFilterFields]="['codDealer']" paginatorDropdownAppendTo="body">

  <ng-template #message pTemplate="emptymessage" let-columns>
    <tr *ngIf="dados?.length != 0">
      <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
        style="padding: 20px;">
        <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="2">
        Todos os Tipos
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="7">
        Mês
      </th>
    </tr>
    <tr>
      <ng-container *ngFor="let col of columns">
        <th [pSortableColumn]="col.field" style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
          [ngStyle]="{'width': col.width}">
          {{col.header}}
          <p-sortIcon [field]="col.field" class="p-sortable-colum"
            *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
          </p-sortIcon>
        </th>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-dados let-columns="columns">
    <tr>
      <td *ngFor="let col of columns">
        <div *ngIf="col.field != 'visivel'">
          {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer" let-dados let-columns="columns">
    <tr>
      <td class="text-center" style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
        colspan="2">
        Brasil
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisPrincipal.totalBudgetFull}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisPrincipal.totalBudgetMtd}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisPrincipal.totalRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisPrincipal.totalDescontoMes}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisPrincipal.totalComDescontoMes}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisPrincipal.totalGapMesFull}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisPrincipal.totalGapMesYtd}}
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="card" *ngIf="dados?.length === 0">
  <div class="card-body bg-no-records p-shadow-3">
    <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
  </div>
</div>